import React from "react";

import { Modal, ModalInput, modalConnect } from "@modal";

import {
  ceModalEditSubjectCancel,
  ceModalEditSubjectSave,
} from "@js/actions/studio/campaign_content_section/modal_edit_subject.js";

import { ceModalUpdateState } from "@js/actions/studio/modals.js";

const ModalEditSubject = (props) => {
  return (
    <Modal
      title={t("phrases.react_content.action_dropdown.edit_subject")}
      onCancel={() => props.dispatch(ceModalEditSubjectCancel())}
      onSave={() => props.dispatch(ceModalEditSubjectSave())}
    >
      <ModalInput
        type="text"
        onChange={(e) =>
          props.dispatch(ceModalUpdateState({ subject: e.target.value }))
        }
        value={props.subject || ""}
        error={props.validation_error}
        onEnter={() => props.dispatch(ceModalEditSubjectSave())}
        autoFocus
      />
    </Modal>
  );
};

export default modalConnect(ModalEditSubject);
